import SessionStorage from './SessionStorage';

export const SESSION_STORAGE_KEYS = {
  IOS_INSTALLATION_ID: 'ios_installation_id'
} as const;

export const captureAndStoreInstallationID = (
  queryParams: Record<string, string | string[] | undefined>,
  isRouterReady = true
): { installationID?: string } => {
  if (typeof window === 'undefined' || !isRouterReady) {
    return {};
  }

  const installationID = queryParams?.installationID;
  
  if (installationID) {
    const singleInstallID = Array.isArray(installationID) ? installationID[0] : installationID;
    SessionStorage.setSessionStorageItem(SESSION_STORAGE_KEYS.IOS_INSTALLATION_ID, singleInstallID);
    return { installationID: singleInstallID };
  }
  
  const storedInstallID = SessionStorage.getSessionStorageItem(SESSION_STORAGE_KEYS.IOS_INSTALLATION_ID);
  return storedInstallID ? { installationID: storedInstallID } : {};
};

export const retrieveInstallationID = (): { installationID?: string } => {
  const storedInstallID = SessionStorage.getSessionStorageItem(SESSION_STORAGE_KEYS.IOS_INSTALLATION_ID);
  
  if (storedInstallID) {
    return { installationID: storedInstallID };
  }
  
  if (typeof window !== 'undefined') {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const installationID = urlParams.get('installationID');
      return installationID ? { installationID } : {};
    } catch {
      return {};
    }
  }
  
  return {};
};

export const extractiOSInstallationID = captureAndStoreInstallationID;
export const getIOSInstallationID = retrieveInstallationID;
